var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-box"},[_c('label',{staticClass:"check-box-container"},[_c('input',{attrs:{"type":"checkbox"},on:{"click":_vm.checkBoxClicked}}),_c('span',{staticClass:"checkmark"}),_vm._t("terms")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }